import get from '../../utils/object/get';
import type { ThemeColor } from '../types';
import fromTheme from './fromTheme';

const color = <P extends ThemeColor>(colorPath: P) => fromTheme((theme) => get(colorPath, theme.colors));

export default color;
